import { showMyAccount } from '@/utils/getNavList';
import Header from './components/Header';
import UserOptions from './components/UserOptions';
import { PATH } from '@/utils/routes';
import { handleRouteChangesOnClick } from '@/utils/handleRouteChangesOnClick';
import { useEffect } from 'react';
import { useSSRSelector } from '@/redux/ssrStore';

const MyAccount = () => {
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);

  useEffect(() => {
    if (storeInfo?.store_id && !showMyAccount()) {
      handleRouteChangesOnClick(PATH.PRODUCT);
    }
  }, [storeInfo.store_id]);

  return (
    <div className="tw-h-screen tw-w-screen">
      <Header />
      <UserOptions />
    </div>
  );
};

export default MyAccount;
